import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/index'
import Test from '@/pages/login/views/test'
import pageRouters from '@/pages/page-routers'
import routerConfig from './router-config-prod'
import operationFlow from '@/pages/home/productAndService/bigData/operationFlow.vue'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        fullScreen: true
      }
    },
    {
      path: '/operation-flow',
      name: 'operationFlow',
      component: operationFlow,
      meta: {
        fullScreen: true
      }
    }
  ].concat(pageRouters
    .map(router => {
      const config = routerConfig[router.name]
      if (!config || config.enabled) {
        return router
      }
      return {
        path: router.path,
        name: router.name,
        component: Test
      }
    })
  )
})



// WEBPACK FOOTER //
// ./src/router/index.js